module.exports = __webpack_public_path__ + "assets/img/3_1226_big.0083b369.jpg";